// extracted by mini-css-extract-plugin
export default {"page":"oH","wrapper":"pH","text":"qH","icons":"rH","icon":"sH","icon_text":"tH","carousel_wrapper":"uH","slide":"vH","image":"wH","arrows":"xH","prev":"yH","modal_root":"zH","x_mark":"AH","modal":"BH","images":"CH","main_image":"EH","name":"FH"};
    if(module.hot) {
      // 1713361651667
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  